import React from "react";
import './TabItem.css';
import { motion } from 'framer-motion';
import PostsList from "../../components/Blogs/HomePage";

const blogs = [
    {
        imgUrl: "./img/services/crm-solutions/customizable-template.jpg",
        imgAlt: "A business dashboard powered by Dynamics 365",
        title: "Top Features of Dynamics 365 for 2024",
        date: "2024-12-01",
        excerpt: "Explore the top features of Microsoft Dynamics 365 for businesses in 2024."
    },
    {
        imgUrl: "./img/services/crm-solutions/multi-user-collab.png",
        imgAlt: "CRM interface on Dynamics 365",
        title: "How Dynamics 365 Simplifies CRM",
        date: "2024-11-25",
        excerpt: "Learn how Dynamics 365 is making CRM management intuitive and efficient."
    },
    {
        imgUrl: "./img/services/finance-automation/automated-billing-invoicing.png",
        imgAlt: "Team using Dynamics 365 for collaboration",
        title: "Collaboration Made Easy with Dynamics 365",
        date: "2024-11-10",
        excerpt: "Discover how Dynamics 365 enhances teamwork and cross-department collaboration."
    },
    {
        imgUrl: "./img/services/finance-automation/payroll-automation.jpg",
        imgAlt: "Business data analysis using Dynamics 365",
        title: "Optimizing Business Analytics with Dynamics 365",
        date: "2024-10-25",
        excerpt: "Understand how to use Dynamics 365 for in-depth business analysis."
    },
    {
        imgUrl: "./img/services/finance-automation/tax-compliance.jpg",
        imgAlt: "Customer service support using Dynamics 365",
        title: "Dynamics 365 for Customer Service Excellence",
        date: "2024-10-05",
        excerpt: "Explore how Dynamics 365 is elevating customer service to new heights."
    },
    {
        imgUrl: "./img/services/ai-insights/customer-insights.jpg",
        imgAlt: "ERP module in Dynamics 365",
        title: "Mastering ERP with Dynamics 365",
        date: "2024-09-20",
        excerpt: "Learn the essentials of using Dynamics 365 as a powerful ERP tool."
    },
    {
        imgUrl: "./img/services/ai-insights/auto-decision-making.jpg",
        imgAlt: "Integration tools for Dynamics 365",
        title: "Seamless Integration with Dynamics 365",
        date: "2024-09-05",
        excerpt: "Learn about integration tools and techniques for Dynamics 365."
    },
    {
        imgUrl: "./img/services/ai-insights/realtime-insights.jpg",
        imgAlt: "A manufacturing business using Dynamics 365",
        title: "Dynamics 365 for Manufacturing Businesses",
        date: "2024-08-20",
        excerpt: "See how Dynamics 365 is tailored for the manufacturing sector."
    },
    {
        imgUrl: "./img/services/customization/custom-entities-and-fields.jpg",
        imgAlt: "Retail industry utilizing Dynamics 365",
        title: "Dynamics 365 for Retail: A Comprehensive Guide",
        date: "2024-08-05",
        excerpt: "Explore how Dynamics 365 is revolutionizing the retail industry."
    },
    {
        imgUrl: "./img/services/customization/custom-wf.png",
        imgAlt: "Dynamics 365 finance tools in action",
        title: "Managing Finances with Dynamics 365",
        date: "2024-07-15",
        excerpt: "Learn how to use Dynamics 365 for efficient financial management."
    }
];



const DynamicsD365 = () => {
    return (
        <motion.div
            key="div0"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={{ duration: 0.7 }}
        >
            <PostsList data={blogs} />
        </motion.div>
    );
};

export default DynamicsD365;
